var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGwin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      maxHeight: 500
    },
    viewBox: "389.11922887240667 263.8124502784563 203.26648975789803 55.61319508762413",
    width: 203.26648975789803,
    height: 55.61319508762413,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_0",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.28)",
    d: "M0 595.28H841.89V0H0Z",
    fill: "#ffffff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_0)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,437.5611,267.15245)",
    d: "M0 0V-14.397C0-14.397-2.639-10.268-15.381-10.268-28.125-10.268-30.393-20.535-30.393-24.045-30.393-27.549-29.327-35.486-21.362-39.471-17.229-41.535-10.061-39.471-10.061-39.471V-31.838H-20.948L-15.018-20.947H4.125V-44.582C4.125-44.582-3.461-51.182-19.707-51.182-35.957-51.182-46.565-39.447-46.565-24.639-46.565-7.629-33.569-2.158-30.569-.826-26.471 1.004-17.424 1.771-8.607 1.154-2.42 .723 0 0 0 0",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,441.6861,265.58995)",
    d: "M0 0 12.93-50.016H27.893L37.247-28.414 47.117-49.84H61.746L72.804 .168H56.297L52.218-27.047 37.074 .846 22.787-27.221 17.687 0Z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.28)",
    d: "M518.783 329.787H533.702V279.85899H518.783Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,574.0335,315.42124)",
    d: "M0 0-.435 .69C-9.307 14.722-14.447 22.947-16.152 25.833-16.942 27.171-17.751 28.622-18.574 30.177-18.416 25.832-18.338 21.089-18.338 16.005V0H-32.335V49.928H-15.839L-2.928 29.968C-1.574 27.83-.177 25.355 1.253 22.565 1.068 26.065 .975 30.025 .975 34.412V49.928H14.972V0Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,319.5567,253.36454)",
    d: "M0 0V-61.339H63.273Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,302.4098,314.70344)",
    d: "M0 0C-7.123 9.041-11.385 20.442-11.385 32.843-11.385 62.187 12.403 85.975 41.746 85.975 51.315 85.975 60.285 83.431 68.039 79.004L78.194 96.563C67.451 102.721 55.016 106.261 41.746 106.261 1.199 106.261-31.671 73.391-31.671 32.843-31.671 21.034-28.867 9.884-23.912 0Z",
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGwin);
export default __webpack_public_path__ + "static/media/gwin.de235d299b18dd0fc641f68c5d1a9691.svg";
export { ForwardRef as ReactComponent };